export default {
  borderColor: 'brandOne10',
  borderColorInverse: 'brandOne50',
};
